const Validator = {

  isPhonenumber(str) {
    return /^[1][3,4,5,7,8][0-9]{9}$/.test(str) ? true : false
  }

}

export default {
  install(Vue) {
    Vue.prototype.$validator = Validator
  }
}
